var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-dialog", {
    attrs: {
      title: _vm.$gettext("Seite exportieren"),
      confirmText: this.$gettext("Erstellen"),
      confirmClass: "accept",
      closeText: this.$gettext("Schließen"),
      closeClass: "cancel",
      height: "350",
    },
    on: {
      close: function close($event) {
        return _vm.showElementPdfExportDialog(false)
      },
      confirm: _vm.pdfExportCurrentElement,
    },
    scopedSlots: _vm._u([
      {
        key: "dialogContent",
        fn: function fn() {
          return [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$gettextInterpolate(
                    _vm.$gettext(
                      'Hiermit exportieren Sie die Seite "%{ pageTitle }" als PDF-Datei.'
                    ),
                    {
                      pageTitle: _vm.structuralElement.attributes.title,
                    }
                  )
                ) +
                "\n        "
            ),
            _c(
              "div",
              {
                staticClass: "cw-element-export",
              },
              [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.pdfExportChildren,
                        expression: "pdfExportChildren",
                      },
                    ],
                    attrs: {
                      type: "checkbox",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.pdfExportChildren)
                        ? _vm._i(_vm.pdfExportChildren, null) > -1
                        : _vm.pdfExportChildren,
                    },
                    on: {
                      change: function change($event) {
                        var $$a = _vm.pdfExportChildren,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.pdfExportChildren = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.pdfExportChildren = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.pdfExportChildren = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$gettext("Unterseiten exportieren")) +
                      "\n            "
                  ),
                ]),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }